import React, { Component } from 'react';
import ButtonCore from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import '../assets/styles/button.css';

/**
 * Button komponenta.
 */
class Button extends Component {
    /**
     * Default props.
     *
     * @type {{
     *     color: string,
     *     size: string,
     *     variant: string,
     *     className: string,
     *     onClick: function,
     *     disabled: boolean,
     *     loading: boolean,
     * }}
     */
    static defaultProps = {
        color: 'primary',
        size: 'large',
        variant: 'contained',
        className: '',
        onClick: () => {},
        disabled: false,
        loading: false,
        style: {}
    };

    /**
     * Event po kliknuty.
     */
    onClick() {
        this.props.onClick();
    }

    /**
     * Rendrovanie.
     *
     * @returns {JSX.Element}
     */
    render() {
        const { color, size, variant, className, disabled, children, loading, style } = this.props;

        const content = loading
            ? (
                <div>
                    <CircularProgress className="loading" color="inherit" size={20} />
                    <div style={{ opacity: 0 }}>{children}</div>
                </div>
            )
            : children;

        return <ButtonCore
            onClick={this.onClick.bind(this)}
            className={`button button-${!disabled ? color : 'disabled'} ${className}`}
            variant={variant}
            color="inherit"
            size={size}
            disabled={disabled || loading}
            style={style}
        >{content}</ButtonCore>;
    }
}

export { Button };
